import reducer from './reducers/index';
//@ts-ignore
import ResponseWatcher from './processed-response-watcher';
//@ts-ignore
import NavWatcher from './autonav-watcher';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';

export default class AutoNavUrl {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _responseWatcher: ResponseWatcher;
    _autoNavWatcher: NavWatcher;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
        this._responseWatcher = new ResponseWatcher(settings);
        this._autoNavWatcher = new NavWatcher(settings);
    }

    getReducer() {
        return reducer;
    }

    initialize(store: Store<AlmeState>) {
        this._responseWatcher.initialize(store);
        this._autoNavWatcher.initialize(store);
    }
}



// WEBPACK FOOTER //
// ./modules/auto-nav-url-aon/auto-nav-url-aon.ts